'use strict';

import passRules from '../../modules/passRules';

const showResetPassword = {
  settings: {
    $form: document.querySelector('.o-forms'),
  },

  init() {
    passRules.init();

    s.$form.length &&
      s.$form.addEventListener('submit', function (e) {
        if (!passRules.settings.submit) {
          e.preventDefault();
        }
      });
  },
};

const _this = showResetPassword,
  s = _this.settings;

export default _this;
